/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Box, Skeleton } from "@mui/material";
import useCurrentActionCache from "../../../hooks/useCurrentActionCache";
import { CACHE_ADB } from "../../../constants/actionCache";
import Provinces from "../components/Province/Provinces";
import Districts from "../components/District/Districts";
import Wards from "../components/Ward/Wards";
import ShowCacheADB from "../components/ShowCacheADB";
import ADBImport from "../components/ADBImport";
import { useCallback } from "react";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";

const AdministrativeBoundaries = () => {
  // disable action deploy
  const [disableButton, setDisableButton] = useState(false);

  // cache
  const { currentActionCache, setCurrentActionCache } = useCurrentActionCache();

  // selected Province, district, Ward data
  const [provinceId, setProvinceId] = useState();
  const [districtId, setDistrictId] = useState();
  const [wardId, setWardId] = useState();

  // loading when submit file
  const [isLoading, setIsLoading] = useState(false);

  const handleUploadFile = useCallback(() => {
    setIsLoading(false);
    setCurrentActionCache(CACHE_ADB);
  }, [setCurrentActionCache]);

  return (
    <div className="container">
      <div
        style={{ display: "flex", justifyContent: "end", marginBottom: "25px" }}
      >
        <DeployCache
          title="Cache Administrative Boundaries"
          cache={CACHE_ADB}
          isShowButton={isShowCache(currentActionCache, CACHE_ADB)}
        >
          <ShowCacheADB
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>

        <ADBImport
          onUploadSuccess={handleUploadFile}
          setIsLoading={setIsLoading}
        />
      </div>

      {isLoading ? (
        <Box>
          <h3 style={{ textAlign: "center" }}>Đang Khởi Tạo Dữ Liệu</h3>
          <Skeleton animation="wave" height={118} />
        </Box>
      ) : (
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <Provinces provinceId={provinceId} setProvinceId={setProvinceId} />
          <Districts
            provinceId={provinceId}
            districtId={districtId}
            setDistrictId={setDistrictId}
          />
          <Wards
            districtId={districtId}
            wardId={wardId}
            provinceId={provinceId}
            setWardId={setWardId}
          />
        </div>
      )}
    </div>
  );
};

export default AdministrativeBoundaries;
